import { render, staticRenderFns } from "./edit-category.vue?vue&type=template&id=53ca52b8&"
import script from "./edit-category.vue?vue&type=script&lang=ts&"
export * from "./edit-category.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports